import { useNavigate, useParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Separator } from '@/components/ui/separator';
import { ChannelGuideForm } from './channelGuideForm';
import { ChannelGuide } from '@/lib/schema/channelGuide';
import { updateChannelGuide, useChannelGuide } from '@/lib/api/channelGuide';
import { Channels } from './channels/channels';
import { GuideSyncBanner } from './guideSyncBanner';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

function submitChannelGuide(data: ChannelGuide) {
  return updateChannelGuide(data.id!, data);
}

export function UpdateChannelGuide() {
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();
  const [data, isLoading] = useChannelGuide(id);

  const mutation = useMutation({
    mutationFn: submitChannelGuide,
    onSuccess: () => {
      navigate(-1);
    },
    onError: (error) => {
      console.error('Error creating TV controller:', error);
    },
  });

  const onSubmit = (data: any) => {
    mutation.mutate({ ...data, id });
  };

  if (isLoading || !id) {
    return null;
  }

  return (
    <div className="w-full pb-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold">Update channel guide</h1>
        </div>
      </div>

      <Separator className="my-6" />

      <GuideSyncBanner guide={{ ...data, id }} />

      <Tabs defaultValue="channels">
        <TabsList>
          <TabsTrigger value="channels">Channels</TabsTrigger>
          <TabsTrigger value="guide">Guide</TabsTrigger>
        </TabsList>
        <TabsContent value="channels">
          <Channels channelGuide={data} />
        </TabsContent>
        <TabsContent value="guide">
          <ChannelGuideForm
            channelGuideId={id}
            channelGuide={data}
            mutation={mutation}
            onSubmit={onSubmit}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
}
